export const SHERIFF_GOOGLE_PLAY_TIMELINE = "google-play-sheriff_0";

export const SHERIFF_USER_LIST_HIDE = "sheriff-hide";
